module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fillCompanyInfo":"You must fill the company information before posting a job","fill":"Fill in"}}')
  delete Component.options._Ctor
}
